// extracted by mini-css-extract-plugin
module.exports = {"img":"_38F5h3KBBwS7kFaIwm1_Qz","price":"_3yWu5hNwmE8sNUK_A-kEMK","icons":"_1ZQv-o2Tlz--jCCgy32j9Y","info":"_2RuJWk285NmOInIyniqdNS","item":"HjTOn7YRM8QQETzxw3WeX"};